<template lang="pug">
  the-fade
    the-main-visual
    the-vr-office-tour.u_pos-rel(:style="{ zIndex: 4 }")
    the-gallery.u_pos-rel(:style="{ zIndex: 3 }")
    the-concept.u_pos-rel(:style="{ zIndex: 4 }")
    the-scene.u_pos-rel(:style="{ zIndex: 5 }")
    the-contact
    the-modal
</template>

<script>
  import TheFade from '@/components/TheFade'
  import TheMainVisual from '@/components/top/TheMainVisual'
  import TheModal from '@/components/TheModal'

  import TheVrOfficeTour from '@/components/top/TheVrOfficeTour'
  import TheGallery from '@/components/top/TheGallery'
  import TheConcept from '@/components/top/TheConcept'
  import TheScene from '@/components/top/TheScene'
  import TheContact from '@/components/top/TheContact'
  export default {
    name: 'index',
    components: {
      TheFade,
      TheMainVisual,
      TheModal,
      TheVrOfficeTour,
      TheGallery,
      TheConcept,
      TheScene,
      TheContact,
    },
    watch: {
      '$route': function (n, o) {
        if (n.hash.match(/^#/)) {
          this.scrollToTargetSection(n.hash)
        }
      },
      '$store.state.isLoading': function () {
        if (!this.$store.state.isLoading) {
          let hash = this.$route.hash
          if (hash) {
            this.scrollToTargetSection(hash)
          }
        }
      }
    },
    mounted () {
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/page/index.vue